import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';

export default function NonBlockingLoader({ open, message, autohideDuration, closeSnackbar }) {
  const onClose = closeSnackbar || null;
  const isOpen = open !== undefined ? open : true;
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={isOpen}
      message={message}
      autoHideDuration={autohideDuration}
      onClose={onClose}
    />
  );
}
